/* __next_internal_client_entry_do_not_use__ default auto */ import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useNewOrder } from '@/context/NewOrderContext';
import { Autocomplete, OutlinedInput, TextField } from "__barrel_optimize__?names=Autocomplete,OutlinedInput,TextField!=!@mui/material";
import React from 'react';
import AddressField from './AddressField';
import { MuiTelInput } from 'mui-tel-input';
import { doc, updateDoc } from 'firebase/firestore';
import { firestore } from '@/lib/firebase/firebase';
function VehicleInformation() {
    const { order, setOrder } = useNewOrder();
    const [allMakes, setAllMakes] = React.useState([]);
    const [allModels, setAllModels] = React.useState([]);
    React.useEffect(()=>{
        (async ()=>{
            try {
                const requestUrl = 'https://vpic.nhtsa.dot.gov/api/vehicles/GetMakesForVehicleType/car?format=json';
                const response = await fetch(requestUrl);
                if (!response.ok) {
                    throw new Error('Failed to fetch makes');
                }
                const data = await response.json();
                const makes = data.Results.map((make)=>make.MakeName).sort();
                setAllMakes(makes);
            } catch (error) {
                console.error('Error fetching makes:', error);
            }
        })();
    }, []);
    React.useEffect(()=>{
        if (!order.vehicle.make || !order.vehicle.year) {
            setAllModels([]);
            return;
        }
        (async ()=>{
            try {
                const requestUrl = "https://vpic.nhtsa.dot.gov/api/vehicles/GetModelsForMakeYear/make/".concat(order.vehicle.make.toLowerCase(), "/modelyear/").concat(order.vehicle.year, "?format=json");
                const response = await fetch(requestUrl);
                if (!response.ok) {
                    throw new Error('Failed to fetch models');
                }
                const data = await response.json();
                const models = data.Results.map((model)=>model.Model_Name).sort();
                const uniqueModels = Array.from(new Set(models));
                setAllModels(uniqueModels);
            } catch (error) {
                console.error('Error fetching models:', error);
            }
        })();
    }, [
        order.vehicle.make,
        order.vehicle.year
    ]);
    const handleVehicleDataChange = async (field, value)=>{
        setOrder((prev)=>({
                ...prev,
                vehicle: {
                    ...prev.vehicle,
                    [field]: value
                }
            }));
        if (order.id) {
            const docRef = doc(firestore, 'orders', order.id);
            await updateDoc(docRef, {
                vehicle: {
                    ...order.vehicle,
                    [field]: value
                }
            });
        }
    };
    const handleFlatDataChange = async (field, value)=>{
        setOrder((prev)=>({
                ...prev,
                [field]: value
            }));
        if (order.id) {
            const docRef = doc(firestore, 'orders', order.id);
            await updateDoc(docRef, {
                [field]: value
            });
        }
    };
    return /*#__PURE__*/ _jsxs("div", {
        className: "flex flex-col gap-5 mt-10",
        children: [
            /*#__PURE__*/ _jsx("div", {
                children: /*#__PURE__*/ _jsx("span", {
                    className: "text-xl",
                    children: "Vehicle Information"
                })
            }),
            /*#__PURE__*/ _jsx("div", {
                className: "bg-neutral-100 p-5 rounded-xl",
                children: /*#__PURE__*/ _jsxs("div", {
                    className: "grid grid-cols-1 md:grid-cols-3 gap-3",
                    children: [
                        /*#__PURE__*/ _jsx(OutlinedInput, {
                            value: order.vehicle.year,
                            onChange: (e)=>handleVehicleDataChange('year', parseInt(e.target.value) || new Date().getFullYear()),
                            fullWidth: true,
                            name: "year",
                            placeholder: "Vehicle Year"
                        }),
                        /*#__PURE__*/ _jsx(Autocomplete, {
                            disablePortal: true,
                            options: allMakes,
                            value: order.vehicle.make,
                            inputValue: order.vehicle.make,
                            onInputChange: (event, newInputValue)=>{
                                handleVehicleDataChange('make', newInputValue);
                            },
                            renderInput: (params)=>/*#__PURE__*/ _jsx(TextField, {
                                    ...params,
                                    name: "make",
                                    placeholder: "Vehicle Make",
                                    fullWidth: true
                                })
                        }),
                        /*#__PURE__*/ _jsx(Autocomplete, {
                            disablePortal: true,
                            options: allModels,
                            value: order.vehicle.model,
                            inputValue: order.vehicle.model,
                            onInputChange: (event, newInputValue)=>{
                                handleVehicleDataChange('model', newInputValue);
                            },
                            renderInput: (params)=>/*#__PURE__*/ _jsx(TextField, {
                                    ...params,
                                    name: "model",
                                    placeholder: "Vehicle Model",
                                    fullWidth: true
                                })
                        }),
                        /*#__PURE__*/ _jsx(OutlinedInput, {
                            value: order.vehicle.vin,
                            onChange: (e)=>handleVehicleDataChange('vin', e.target.value),
                            name: "vin",
                            fullWidth: true,
                            className: "md:col-span-2",
                            placeholder: "Vehicle VIN (Optional)"
                        }),
                        /*#__PURE__*/ _jsx(OutlinedInput, {
                            value: order.stock_number,
                            onChange: (e)=>handleFlatDataChange('stock_number', e.target.value),
                            name: "stock_number",
                            fullWidth: true,
                            placeholder: "Stock Number (Optional)"
                        }),
                        /*#__PURE__*/ _jsx(AddressField, {})
                    ]
                })
            }),
            /*#__PURE__*/ _jsx("div", {
                children: /*#__PURE__*/ _jsx("span", {
                    className: "text-xl",
                    children: "Seller Contact Information"
                })
            }),
            /*#__PURE__*/ _jsx("div", {
                className: "bg-neutral-100 p-5 rounded-xl",
                children: /*#__PURE__*/ _jsxs("div", {
                    className: "grid grid-cols-1 md:grid-cols-3 gap-3",
                    children: [
                        /*#__PURE__*/ _jsx(OutlinedInput, {
                            value: order.vehicle_contact_name,
                            onChange: (e)=>handleFlatDataChange('vehicle_contact_name', e.target.value),
                            fullWidth: true,
                            name: "vehicle_contact_name",
                            placeholder: "Seller Contact Name"
                        }),
                        /*#__PURE__*/ _jsx(OutlinedInput, {
                            value: order.vehicle_contact_email,
                            onChange: (e)=>handleFlatDataChange('vehicle_contact_email', e.target.value),
                            fullWidth: true,
                            name: "vehicle_contact_email",
                            placeholder: "Seller Contact Email"
                        }),
                        /*#__PURE__*/ _jsx(MuiTelInput, {
                            value: order.vehicle_contact_phone,
                            onChange: (e)=>handleFlatDataChange('vehicle_contact_phone', e),
                            onlyCountries: [
                                'US',
                                'CA'
                            ],
                            defaultCountry: "US",
                            fullWidth: true,
                            name: "vehicle_contact_phone",
                            placeholder: "Seller Contact Phone"
                        }),
                        /*#__PURE__*/ _jsx(OutlinedInput, {
                            className: "md:col-span-3",
                            value: order.dealership_name,
                            onChange: (e)=>handleFlatDataChange('dealership_name', e.target.value),
                            fullWidth: true,
                            name: "dealership_name",
                            placeholder: "Dealership Name (Optional)"
                        })
                    ]
                })
            })
        ]
    });
}
export default VehicleInformation;
